<template>
  <button-vue
    :class="className"
    :copy="copy"
    :href="href"
    :event-category="eventCategory"
    :event-name="plan.type"
    :is-cta="true"
    v-bind="dataAttributes"
  />
</template>

<script>
import Button from "@/shared/button"
import user from "@/utils/user"

export default {
  name: "OrderCta",
  components: { ButtonVue: Button },
  props: {
    plan: { type: Object, required: true },
    copy: { type: String, default: "" },
    eventCategory: { type: String, default: "body-20200305-order_cta" },
    /* clickAction possible values: "redirect", "login", "signup" */
    clickAction: { type: String, default: "redirect" },
    isUserLoggedIn: { type: Boolean, default: user.isLoggedIn() }
  },
  computed: {
    href() {
      return this.plan.link
    },
    className() {
      return {
        "order-cta": true,
        "js-open-login-popup": this.clickAction === "login",
        "js-open-signup-popup": this.clickAction === "signup"
      }
    },
    dataAttributes() {
      if (this.isUserLoggedIn) {
        return {}
      }
      return {
        "data-sku": this.plan.sku,
        "data-login-path": this.plan.loginPath,
        "data-signup-path": this.plan.signupPath
      }
    }
  }
}
</script>
